<template>
  <div id="top-bar-component">
    <v-app-bar window class="first-top-bar px-xs-2 px-sm-5 px-md-10">
      <div v-if="!getBranginLogoUrl" class="main-logo mx-1">
            <img
              v-if="$vuetify.theme.name === 'light'"
              src="../../../assets/images/tw-main-logo-light.png"
              :alt="brandLogoAlt"
            />
            <img
              v-if="$vuetify.theme.name === 'dark'"
              src="../../../assets/images/tw-main-logo-dark.png"
              :alt="brandLogoAlt"
            />
      </div>
      <a v-else
          :href="getBrandingHomepage"
          class="main-logo mx-1 d-flex align-center justify-center"
          style="width: auto !important;">
        <img :src="getBranginLogoUrl" style="width: auto !important;" :alt="brandLogoAlt" />
      </a>

      <v-spacer></v-spacer>

      <div v-if="getExpireAt" class="mr-4">
        {{$t("routes.accesslink.linkExpiresAt")}} {{ isoToDate(getExpireAt) }} ({{$t('common.time.days', getExpiryDays)}})
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import { useUploadLinkStore } from '@/stores/UploadLinkStore.js';
import { isoToDate } from '@/components/formatters.js';

export default {
  name: "UploadlinkTopBar",
  methods: {
    isoToDate
  },
  computed: {
    getUploadlinkInfo() {
      const uploadLinkStore = useUploadLinkStore();
      return uploadLinkStore.getUploadlinkInfo;
    },
    getBrandingInfo() {
      if (this.getUploadlinkInfo && this.getUploadlinkInfo.brand) {
        return this.getUploadlinkInfo.brand;
      }

      return null;
    },
    getBrandingHomepage() {
      if (this.getBrandingInfo) {
        return this.getBrandingInfo.alias;
      }

      return null;
    },
    brandLogoAlt() {
      return this.getBrandingInfo?.name || 'TubeWay';
    },
    getBranginLogoUrl() {
      if (this.getBrandingInfo && this.getBrandingInfo.logoUrl) {
        return this.getBrandingInfo.logoUrl;
      }

      return null;
    },
    getExpireAt() {
      if (this.getUploadlinkInfo && this.getUploadlinkInfo.expireat) {
        return this.getUploadlinkInfo.expireat;
      }

      return "";
    },
    getExpiryDays() {
      if (this.getExpireAt) {
        const expDate = new Date(this.getExpireAt);
        const now = new Date();

        const diff = Math.floor((expDate - now) / 86400000);
        return diff;
      }

      return '';
    }
  }
};
</script>

<style scoped>
.first-top-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.main-logo {
  height: 30px;
  display: flex;
  align-items: center;
}

.main-logo img {
  /* max-height: 30px; */
}
</style>
